const rules = {
  RONAD_ADMIN: {
    static: [
      '/',
      '/orders',
      '/orders/:id',
      '/orders/:id/allLogs',
      '/bundles',
      '/bundles/:id',
      '/bundles/:id/allLogs',
      'bundles:history',
      'bundles:changeStatus',
      '/users',
      '/helpicalusers',
      '/partners',
      '/centers',
      '/centers/:partnerId',
      '/products',
      '/products/:partnerId',
      '/warehouses-menu',
      '/warehouses',
      '/warehouses/:id',
      '/warehouses/details/:id',
      '/warehouses/assign-user/:id',
      '/warehouses/children/:warehousesId',
      '/warehouses/inventory',
      '/warehouses/inventory/:warehousesId',
      '/warehouses/inventory/:warehousesId/log/:skuId',
      '/skus/inventory/:skuId/:name',
      '/centersStatistics',
      '/centersStatistics/details/:id/:nameCenter',
      '/inventry-items/:id',
      '/parcels',
      'parcels:change-status',
      '/parcels/details/:id',
      '/parcels/:id/allLogs',
      '/boxes',
      '/login',
      // '/assignment',
      // '/upload-info',
      'orders:btnGetNewOrders',
      'orders:downloadReportCSV',
      'orders:filtersByCenterId',
      'orders:byBundle',
      'orders:history',
      'orders:list:centerName',
      'orders:changeOrderStatus',
      'orders:cancelOrders',
      'post-orders:detail',
      // 'bundles:history',
      // 'driver:shift',
      // 'driver:changeStatus',
      'user:viewUserDetails',
      'user:editUserDetails',
      'user:createNewUser',
      'user:disableUser',
      'partners:editDetails',
      'partners:disablePartner',
      'partners:createNewPartner',
      'centers:editDetails',
      'centers:createNewCenter',
      'centers:downloadReportCSV',
      'centers:disableCenter',
      '/reports',
      '/reports/current-orders',
      '/reports/center-orders/:centerId',
      '/delivery-orders',
      'parcels-sender:changeStatus',
      '/profile',
      'paswd:change'
    ],
  },
  // CENTER_ADMIN: {
  //   static: [
  //     '/',
  //     '/orders',
  //     'orders:changeOrderStatus',
  //     'orders:cancelOrders',
  //     '/delivery-orders',
  //     '/orders/:id',
  //     '/orders/:id/allLogs',
  //     'orders:changeOrderStatus',
  //     '/login',
  //   ],
  // },
  // PARTNER_ADMIN: {
  //   static: [
  //     '/login',
  //     '/your-products',
  //     '/partner-account',
  //     'product:edit',
  //     'product:grouping-create',
  //     '/your-products/:id',
  //     '/your-products/:id/variant/:variantId',
  //     '/your-products/:name/variant/:variantId/inventory-items/:warehouseId',
  //     '/your-products/:id/order/:variantId',
  //     'variant:edit',
  //     '/variant-edit/:id',
  //     '/create-product',
  //     '/create-grouping-product',
  //     '/edit-product/:id',
  //     '/skus/inventory/:skuId/:name',
  //     '/your-centers',
  //     '/orders',
  //     '/orders/:id',
  //     '/orders/:id/allLogs',
  //     '/orders/variantOrders/:id',
  //     'orders:history',
  //     'post-orders:detail',
  //     // '/centersStatistics',
  //     // '/centersStatistics/details/:id/:nameCenter',
  //     '/parcels-sender/:id/conflicts',
  //     'centers:editDetails',
  //     'centers:createNewCenter',
  //     'centers:downloadReportCSV',
  //     'centers:disableCenter',
  //     'orders:downloadReportCSV',
  //     'user-name:dontShowInLogs',
  //     'orders:create',
  //     'orders-info:more-info',
  //     'orders:grouping-create',
  //     'orders:edit',
  //     'orders:filtersByCenterId',
  //     '/orders-create',
  //     '/create-grouping-order',
  //     // '/edit-order/:id',
  //     '/parcels-sender',
  //     '/parcels-sender/add',
  //     '/parcels-sender/:id/edit',
  //     '/parcels-sender/:id/allLogs',
  //     'parcels-sender:editParcel',
  //     'parcels-sender:cancelParcel',
  //     '/parcels/details/:id',
  //     '/parcels/receipts/:id',
  //     'parcels-details:print',
  //     '/print-labels/:id',
  //     'parcels:downloadReportCSV',
  //     'parcels:createNewParcel',
  //     'parcels-detail:downloadCSV',
  //     '/providers',
  //     'providers:disable',
  //     'providers:add',
  //     '/sellers',
  //     'sellers:disable',
  //     'sellers:add',
  //     'orders:cancelOrders',
  //     '/webhooks',
  //     '/webhooks/create',
  //     'parcels-detail:downloadInventoryItemCSV',
  //   ],
  // },
  DRIVER: {
    static: ['/login'],
  },
  MARKETING_MANAGER: {
    // مدیر مارکتینگ
    static: [
      '/login',
      '/orders',
      '/orders/:id',
      '/orders/:id/allLogs',
      'orders:history',
      "/warehouses-menu",
      '/parcels',
      '/parcels/details/:id',
      '/parcels/:id/allLogs',
      // 'bundles:history',
      // '/bundles',
      // '/bundles/:id',
      // '/bundles/:id/allLogs',
      // 'driver:shift',
      // 'driver:changeStatus',
      // 'driver:changeCenter',
      '/users',
      'user:viewUserDetails',
      'user:editUserDetails',
      'user:createNewUser',
      'user:disableUser',
      '/partners',
      'partners:editDetails',
      'partners:disablePartner',
      'partners:disablePartner',
      'partners:createNewPartner',
      '/centers',
      '/centers/:partnerId',
      'centers:editDetails',
      'centers:downloadReportCSV',
      'centers:disableCenter',
      '/profile',
      // '/upload-info',
    ],
  },
  MARKETING_EXPERT: {
    // کارشناس مارکتینگ
    static: [
      '/login',
      '/orders',
      '/orders/:id',
      '/orders/:id/allLogs',
      'orders:history',
      // 'bundles:history',
      // '/bundles',
      // '/bundles/:id',
      // '/bundles/:id/allLogs',
      // 'driver:shift',
      // 'driver:changeStatus',
      '/users',
      'user:viewUserDetails',
      '/partners',
      'partners:editDetails',
      'partners:createNewPartner',
      '/centers',
      '/centers/:partnerId',
      'centers:editDetails',
      'centers:createNewCenter',
      'centers:downloadReportCSV',
      'centers:disableCenter',
      '/profile',
      // '/upload-info',
    ],
  },
  OPERATIONS_MANAGER: {
    // مدیر عملیات
    static: [
      '/login',
      '/orders',
      '/orders/:id',
      '/orders/:id/allLogs',
      'orders:history',
      'orders:btnGetNewOrders',
      'orders:downloadReportCSV',
      'orders:byBundle',
      // 'bundles:history',
      // '/bundles',
      // '/bundles/:id',
      // '/bundles/:id/allLogs',
      // 'driver:shift',
      // 'driver:changeStatus',
      // 'driver:changeCenter',
      '/users',
      'user:viewUserDetails',
      'user:editUserDetails',
      'user:createNewUser',
      'user:disableUser',
      '/partners',
      'partners:editDetails',
      'partners:disablePartner',
      'partners:createNewPartner',
      '/centers',
      '/centers/:partnerId',
      'centers:editDetails',
      'centers:createNewCenter',
      'centers:downloadReportCSV',
      '/profile',
    ],
  },
  OPERATIONS_EXPERT: {
    // کارشناس عملیات
    static: [
      '/login',
      '/orders',
      '/orders/:id',
      '/orders/:id/allLogs',
      'orders:history',
      'orders:btnGetNewOrders',
      'orders:downloadReportCSV',
      'orders:byBundle',
      // 'bundles:history',
      // '/bundles',
      // '/bundles/:id',
      // '/bundles/:id/allLogs',
      // 'driver:shift',
      // 'driver:changeStatus',
      // 'driver:changeCenter',
      '/partners',
      '/centers',
      '/centers/:partnerId',
      'centers:downloadReportCSV',
      '/profile',
    ],
  },
  SUPPORT_MANAGER: {
    // مدیر پشتیبانی
    static: [
      'orders:history',
      '/orders',
      '/orders/:id',
      '/orders/:id/allLogs',
      'orders:btnGetNewOrders',
      'orders:changeOrderStatus',
      'orders:byBundle',
      'orders:cancelOrders',
      '/login',
      '/vip-orders',
      '/vip-orders/:id',
      '/nonPost-orders',
      '/nonPost-orders/:id',
      '/post-orders',
      '/vip-orders/3pl-orders/:id',
      '/nonPost-orders/3pl-orders/:id',
      '/post-print-labels/:id',
      'bundles:history',
      '/bundles',
      '/bundles/:id',
      '/bundles/:id/allLogs',
      'driver:viewShift',
      'driver:changeStatus',
      '/users',
      '/helpicalusers',
      'user:editUserDetails',
      'user:viewUserDetails',
      'user:createNewUser',
      'user:disableUser',
      '/partners',
      'centers:downloadReportCSV',
      '/centers',
      '/centers/:partnerId',
      '/products/:partnerId',
      '/warehouse-admin-parcels-receipts',
      '/parcels-sender',
      '/parcels-sender/:id/allLogs',
      '/parcels/details/:id',
      '/warehouses/your-inventory',
      '/warehouse/inventory',
      '/partner-warehouses/inventory',
      '/create-grouping-inventory',
      '/warehouse-admin-canceled-orders',
      '/profile',
      '/messages',
      '/ticketing',
      '/ticketing-list',
      '/ticketing/:id'
      // '/upload-info',
    ],
  },
  SUPPORT_EXPERT: {
    // کارشناس پشتیبانی
    static: [
      '/login',
      '/orders',
      '/orders/:id',
      '/orders/:id/allLogs',
      'orders:history',
      '/parcels-sender',
      '/parcels/details/:id',
      '/parcels-sender/:id/allLogs',
      'parcels:history',
      'orders:changeOrderStatus',
      'orders:byBundle',
      'orders:cancelOrders',
      '/bundles',
      '/bundles/:id',
      '/bundles/:id/allLogs',
      'bundles:history',
      'bundles:changeStatus',
      '/users',
      'user:viewUserDetails',
      'user:editUserDetails',
      'user:createNewUser',
      'user:disableUser',
      '/profile',
    ],
  },
  // AGENCY_ADMIN: {
  //   static: [
  //     '/login',
  //     '/reports',
  //     '/reports/current-orders',
  //     '/reports/center-orders/:centerId',
  //   ],
  // },
  LOGISTICS_ADMIN: {
    static: [
      '/',
      '/login',
      '/nonPost-orders',
      '/nonPost-orders/:id',
      'orders:list:status',
      '/vip-orders',
      '/vip-orders/:id',
      '/post-orders',
      '/post-print-labels/:id',
      //'/post-orders-queue',
      '/post-orders/:id/send',
      '/post-orders/post-receipt',
      '/orders/:id',
      '/orders/:id/allLogs',
      '/3pl-print-labels/:id',
      'orders:changeOrderStatus',
      'orders:byBundle',
      'orders:history',
      'orders:btnSendPostOrders',
      'orders:downloadReportCSV',
      'orders:cancelOrders',
      'orders:post-tracking-code',
      '/vip-orders/3pl-orders/:id',
      '/nonPost-orders/3pl-orders/:id',
      // '/post-orders-3pl/:id',
      //'/post-orders/receipts/:id',
      '/orders/post/exit-receipts',
      '/create-grouping-3PL',
      'bundles:changeStatus',
      '/pickups',
      '/pickups/details/:id',
      '/parcels/:id/allLogs',
      '/pickups/assignment/:id',
      '/fleets',
      '/fleets/:id/drivers',
      'drivers:downloadReportCSV',
      '/drivers',
      '/bundles',
      '/bundles/:id',
      '/bundles/:id/allLogs',
      '/create-bundle',
      '/edit-bundle/:id',
      'bundles:add',
      'bundles:add-exel',
      'bundles:history',
      'bundles:edit',
      'bundles:cancel',
      '/fleets/:id/drivers/create',
      '/fleets/:fleetId/drivers/:id/edit',
      '/drivers/:id/shifts/:shiftId',
      '/profile',
    ],
  },
  FINANCIAL_SUPERVISOR: {
    static: [
      '/',
      '/login',
      '/drivers-wallet',
      '/drivers-wallet/:id/charge',
      '/drivers-wallet/bulk-charge',
      '/drivers-wallet/:id/history',
      '/profile',
    ],
  },
  // SELLER_ADMIN: {
  //   static: [
  //     '/',
  //     '/login',
  //     '/seller-orders',
  //     // '/orders/:id',
  //     '/seller-products',
  //     '/seller-parcels',
  //     '/seller-parcels/add',
  //     '/seller-parcels/:id/edit',
  //     '/parcels-sender/:id/allLogs',
  //     // 'parcels-sender:editParcel',
  //     // '/parcels-sender/:id/conflicts',
  //     'parcels-sender:cancelParcel',
  //     '/parcels/details/:id',
  //     // '/parcels/receipts/:id',
  //     'parcels:downloadReportCSV',
  //     'parcels:createNewParcel',
  //     'parcels-detail:downloadCSV',
  //     'parcels-detail:downloadInventoryItemCSV',
  //     '/seller-products/:id',
  //     // '/your-products/:id/variant/:variantId',
  //     '/skus/inventory/:skuId/:name',
  //     // '/orders/variantOrders/:id',
  //     'user-name:dontShowInLogs',
  //     // 'parcels-details:print',
  //     // '/print-labels/:id',
  //     '/orders/:id/allLogs',
  //     // '/orders-create',
  //     'orders:create',
  //     // '/create-grouping-order',
  //     'orders:grouping-create',
  //     'orders:downloadReportCSV',
  //     'post-orders:detail',
  //   ],
  // },
  EXCHANGE_ADMIN: {
    static: [
      '/',
      '/login',
      '/bundles-deliver',
      '/bundles/:id',
      '/bundles/:id/allLogs',
      'bundles:history',
      'bundles:deliverToDriver',
      '/bundles/:id/deliver-driver',
      '/organize-bundles',
      '/orders/:id',
      '/deliver-driver-receipt/:id',
      '/deliver/receipts/:id',
      '/profile',
    ],
  },
  FINANCIAL_ADMIN: {
    static: ['/login', '/invoice', '/invoice/:id', 'invoices:changeStatus'],
  },
  NONE: {
    static: ['/login'],
  },
};

export default rules;
